/**
 * Safe clone function that handles circular references properly.
 * Prefers structuredClone for better performance and circular reference handling,
 * falls back to JSON.parse/stringify for older environments.
 */
export const safeClone = <T>(obj: T): T => {
  if (obj === null || typeof obj !== 'object') {
    return obj
  }

  try {
    // Use structuredClone if available (modern browsers/Node.js)
    if (typeof structuredClone !== 'undefined') {
      return structuredClone(obj)
    }
  } catch {
    // structuredClone might fail on frozen objects (from Apollo Client) or objects with functions
    // Silently fall back to JSON clone (no warning needed as this is expected behavior)
  }

  try {
    // Fallback to JSON clone for simpler objects without circular references
    return JSON.parse(JSON.stringify(obj))
  } catch (error) {
    console.error('JSON clone failed due to circular references or unsupported types:', error)
    // This should not happen in the context of Immer state management,
    // but if it does, return the original object to avoid crashes
    return obj
  }
}
